import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const AsyncDiscoverSection = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-app-menu-recommended-apps" */ './discover-section/DiscoverSection.tsx'
		).then((module) => module.DiscoverSection),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

export const AsyncDiscoverSectionPostOffice = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-app-menu-recommended-apps-post-office" */ './discover-section-post-office/DiscoverSectionPostOffice.tsx'
		).then((module) => module.DiscoverSectionPostOffice),
	{
		includeInShellOnlySsrBundle: false,
		entryFsSsrLiftImportToModule: false,
	},
);
